// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1SUB1","content":"GlobalSearch_content__3GLWo"};